<template>
  <body class="hold-transition sidebar-mini sidebar-collapse layout-fixed" id="bodyLMS">
    <section class="content" v-if="route.name == 'Login'">
      <div class="container-fluid">
        <router-view />
      </div>
    </section>
    <div class="wrapper" v-if="route.name != 'Login'">
      <p style="display: none;">Current route name: {{ route.name }}</p>
      <Navbar v-if="route.name != 'Login'"></Navbar>
      <Sidebar v-if="(route.name != 'Login' && this.cekbalai == null)"></Sidebar>
      <SidebarNonAdmin v-if="(route.name != 'Login' && this.cekbalai != null)"></SidebarNonAdmin>

      <div class="content-wrapper">

        <section class="content">
          <div class="container-fluid">
            <router-view />
          </div>
        </section>

      </div>
    </div>
    <Footer v-if="route.name != 'Login'"></Footer>
  </body>
</template>

<script>
import $ from 'jquery';
import "../node_modules/admin-lte/plugins/select2-bootstrap4-theme/select2-bootstrap4.min.css";
import "../node_modules/admin-lte/plugins/select2/css/select2.min.css";
import "../src/assets/css/styleku.css";

import Navbar from "./dashboard/Navbar.vue";
import Sidebar from "./dashboard/Sidebar.vue";
import SidebarNonAdmin from "./dashboard/SidebarNonAdmin.vue";
import Footer from "./dashboard/Footer.vue";
import { useRoute } from 'vue-router';
import { watch } from 'vue';



export default {
  name: "App",
  components: {
    Navbar,
    Sidebar,
    SidebarNonAdmin,
    Footer,
  },
  data() {
    return {
      cekmode: '',
      cekbalai: null,
    }
  },
  methods: {
    initializeSelect2() {
      //Initialize Select2 Elements
      $(".select2").select2();

      //Initialize Select2 Elements
      $(".select2bs4").select2({
        theme: "bootstrap4",
      });
      $('[data-toggle="tooltip"]').tooltip();
    },
    Cek() {
      try {
        this.cekmode = JSON.parse(localStorage.getItem("userLogin"));
        this.cekbalai = this.cekmode.kdbalai;
      }
      catch {
        console.log('');
      }
    }
  },
  mounted() {
    this.initializeSelect2();
    this.Cek();
    document.title = "LMS - Loan Management System";
  },
  setup() {
    const route = useRoute();

    //console.log(`current route name on component setup init: ${route.name}`);

    // You could use computed property which re-evaluates on route name updates
    // const routeName = computed(() => route.name);

    // You can watch the property for triggering some other action on change
    watch(() => route.name, () => {
      //console.log(${route.name});
      // Do something here...

      // Optionally you can set immediate: true config for the watcher to run on init
      //}, { immediate: true });
    });

    return { route };
  }
};
</script>

<style>
/* @import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback");*/
</style>
